import React from "react";

const Footer = () => {
  return (
    <footer className="bg-slate-900 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-8 mb-16">
          {/* Brand */}
          <div className="col-span-2 lg:col-span-2">
            <div className="flex items-center gap-3 mb-6">
              <div className="bg-gradient-to-br from-blue-500 to-indigo-600 p-2.5 rounded-xl">
                <svg
                  className="w-6 h-6 text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                  />
                </svg>
              </div>
              <div className="flex flex-col leading-none">
                <span className="text-xl font-extrabold text-white">
                  Panamá<span className="text-blue-400">BR</span>
                </span>
                <span className="text-[10px] font-bold text-slate-400 mt-0.5 tracking-tighter">
                  by MIVX
                </span>
              </div>
            </div>
            <p className="text-sm text-slate-400 mb-6 leading-relaxed">
              La plataforma líder en preparación para el examen de corredores de
              bienes raíces en Panamá.
            </p>
          </div>

          {/* Links */}
          <div>
            <h3 className="text-white font-bold mb-4">Producto</h3>
            <ul className="space-y-3">
              <li>
                <a
                  href="#features"
                  className="text-sm text-slate-400 hover:text-blue-400 transition-colors"
                >
                  Características
                </a>
              </li>
              <li>
                <a
                  href="#pricing"
                  className="text-sm text-slate-400 hover:text-blue-400 transition-colors"
                >
                  Precios
                </a>
              </li>
              <li>
                <a
                  href="#demo"
                  className="text-sm text-slate-400 hover:text-blue-400 transition-colors"
                >
                  Simulador
                </a>
              </li>
              <li>
                <a
                  href="#testimonials"
                  className="text-sm text-slate-400 hover:text-blue-400 transition-colors"
                >
                  Testimonios
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-bold mb-4">Legal</h3>
            <ul className="space-y-3">
              <li>
                <a
                  href="/legal"
                  className="text-sm text-slate-400 hover:text-blue-400 transition-colors"
                >
                  Términos y condiciones
                </a>
              </li>
              <li>
                <a
                  href="/legal"
                  className="text-sm text-slate-400 hover:text-blue-400 transition-colors"
                >
                  Política de Privacidad
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 border-t border-slate-800 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-slate-500">
            © 2026 PanamaBR. Todos los derechos reservados.
          </p>
          <div className="flex items-center gap-6">
            <span className="text-sm text-slate-500">🇵🇦 Hecho en Panamá</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
